import {
  actionCreator, API_URL,
  checkHttpStatus, create_post_data,
  createRequestActionTypes, createSearchUrl, createSearchUrlWithoutPageNumberAndSize,
  jsonApiHeader, showErrorMessage, showSuccessMessage, showWarningMessage,
} from './../../../actions/utilAction';

export { jsonApiHeader, actionCreator, checkHttpStatus, create_post_data, createSearchUrl, createSearchUrlWithoutPageNumberAndSize, showErrorMessage, showSuccessMessage, showWarningMessage };


export const USER_API = `${API_URL}/staff`;
export const GET_STAFF_PROFILE_DETAILS_API = `${API_URL}/Staffs/GetStaffProfileData`;
export const GET_STAFFDETAILS_API = `${API_URL}/Staffs/GetStaffById`;
export const SAVE_STAFFDETAILS_API = `${API_URL}/Staffs/CreateUpdateStaff`;
export const GET_STAFFS_LIST_API = `${API_URL}/Staffs/GetStaffs`;
export const DELETE_STAFF_API = `${API_URL}/Staffs/DeleteStaff`;
export const GET_PATIENT = `${API_URL}/patient`;
export const GET_USER_LOCATIONS = `${API_URL}/Staff`;
export const GET_USERS = `${API_URL}/Staff`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_MASTER_STATE_BY_COUNTRYID = `${API_URL}/api/MasterData/GetStateByCountryID`;
export const GET_MASTERCUSTOMLABELS = `${API_URL}/StaffCustomLabel/GetStaffCustomLabels`;
export const POST_CUSTOM_VALUES_API = `${API_URL}/StaffCustomLabel/SaveCustomLabels`;
export const GET_AVAILABILITY_TEMPLATE = `${API_URL}/AvailabilityTemplates/GetAvailability`;
export const POST_AVAILABILITY_TEMPLATE_API = `${API_URL}/AvailabilityTemplates/SaveUpdateAvailability`;
export const GET_AVAILABILITY_TEMPLATE_WITH_LOCATION = `${API_URL}/AvailabilityTemplates/GetStaffAvailabilityWithLocation`;
export const POST_AVAILABILITY_TEMPLATE_WITH_LOCATION_API = `${API_URL}/AvailabilityTemplates/SaveUpdateAvailabilityWithLocation`;
export const GET_STAFFBYTAGS_API = `${API_URL}/Staffs/GetStaffByTag`;
export const GET_CLIENTBYTAGS_API = `${API_URL}/Patients/GetPatientByTag`;

// export const USER_TAG = `${API_URL}/staff-tags/postMultiple`;
export const STAFF_STATUS_ACTIVATION = `${API_URL}/staffs/UpdateStaffActiveStatus`;
export const STAFF_SCHEDULER_LOCK = `${API_URL}/staffs/UpdateStaffScheduleLock`;
export const STAFF_LOCK_ACTIVATION = `${API_URL}/user/UpdateUserStatus`;
export const GET_APPLIED_STAFF_LEAVE = `${API_URL}/StaffLeave/GetStaffLeaveList`;
export const POST_STAFF_LEAVE = `${API_URL}/StaffLeave/SaveStaffAppliedLeave`;
export const GET_APPLY_LEAVE_BY_ID = `${API_URL}/StaffLeave/GetAppliedStaffLeaveById`;
export const DELETE_APPLIED_LEAVE = `${API_URL}/StaffLeave/DeleteAppliedLeave`;
export const UPDATE_LEAVE_STATUS = `${API_URL}/StaffLeave/UpdateLeaveStatus`;
export const GET_STAFF_TIME_SHEET_DATA = `${API_URL}/StaffTimesheet/GetStaffTimesheetDataSheetView`;
export const UPDATE_STAFF_TIME_SHEET = `${API_URL}/StaffTimesheet/UpdateStaffTimesheet`;
export const GET_STAFF_TIME_SHEET_DATA_TABLE_VIEW = `${API_URL}/StaffTimesheet/GetStaffTimesheetDataTabularView`;
export const SAVE_USER_TIME_SHEET_DETAILS = `${API_URL}/StaffTimesheet/SaveUserTimesheetDetails`;
export const GET_USER_TIME_SHEET_BY_ID = `${API_URL}/StaffTimesheet/GetUserTimesheetDetails`;
export const DELETE_USER_TIME_SHEET_DETAILS = `${API_URL}/StaffTimesheet/DeleteUserTimesheetDetails`;
export const GET_STAFF_AND_PATIENT_BYLOCATION = `${API_URL}/api/PatientAppointments/GetStaffAndPatientByLocation`;
export const SUBMIT_TIMESHEET_STATUS = `${API_URL}/StaffTimesheet/SubmitUserTimesheet`;
export const GET_DOCTOR_DETAILS_FROM_API = `${API_URL}/Staffs/GetDoctorDetailsFromNPI`;
export const GET_STAFF_PAYROLL_RATE_API = `${API_URL}/StaffPayrollRateForActivity/GetStaffPayRateOfActivity`;
export const POST_STAFF_PAYROLL_RATE_API = `${API_URL}/StaffPayrollRateForActivity/SaveUpdateStaffPayrollRateForActivity`;
export const GET_OFFICE_HOURS_API = `${API_URL}/MasterLocations/GetMinMaxOfficeTime`;
export const GET_STAFF_LOCATIONS_API = `${API_URL}/Staffs/GetAssignedLocationsById`;
export const GET_PATIENT_LIST = `${API_URL}/api/PatientAppointments/GetStaffAndPatientByLocation`;

export const POST_STAFF_INTERNAL_NOTES_API = `${API_URL}/api/StaffInternalNotes/SaveStaffInternalNote`;
export const GET_STAFF_INTERNAL_NOTES_API = `${API_URL}/api/StaffInternalNotes/GetStaffInternalNotes`;
export const DELETE_STAFF_INTERNAL_NOTES_API = `${API_URL}/api/StaffInternalNotes/DeleteStaffInternalNote`;

export const GET_STAFF_TRAINING_TITLE_HOURS_API = `${API_URL}/StaffTrainingTitleHoursForHIH/GetStaffTrainingTitleHoursForHIH`;
export const POST_STAFF_TRAINING_TITLE_HOURS_API = `${API_URL}/StaffTrainingTitleHoursForHIH/SaveUpdateStaffTrainingTitleHoursForHIH`;
export const GET_USERROLES_API = `${API_URL}/UserRole/GetUserRoles`;
export const GET_APPOINTMENTTYPELIST = `${API_URL}/api/PatientAppointments/GetAppointmentTypeList`;
export const POST_RESETUSEREMAIL = `${API_URL}/Staffs/SendMailToResetUserEmail`;
export const POST_CHECKEMAILCHANGEVALIDATION = `${API_URL}/Staffs/CheckEmailChangeValidationLinkIsValid`;

export const userActionTypes = {
  get_appointments: createRequestActionTypes('APPOINTMENTS'),
  get_master_state_by_countryid: createRequestActionTypes('GET_MASTER_STATE_BY_COUNTRYID'),
  save_appointment: createRequestActionTypes('SAVE_APPOINTMENT'),
  save_user: createRequestActionTypes('SAVE_USER'),
  save_staffDetails: createRequestActionTypes('SAVE_STAFFDETAILS'),
  get_staffDetailsById: createRequestActionTypes('GET_STAFFDETAILSBYID'),
  get_staffProfileDetails: createRequestActionTypes('GET_STAFFPROFILEDETAILS'),
  get_user: createRequestActionTypes('SAVE_USER'),
  get_users_by_size: createRequestActionTypes('GET_USER_BY_SIZE'),
  get_all_users: createRequestActionTypes('GET_ALL_USER'),
  get_users_by_location: createRequestActionTypes('GET_USER_BY_SIZE'),
  get_staff_custom: createRequestActionTypes('GET_STAFF_CUSTOM'),
  get_user_locations: createRequestActionTypes('GET_USER_LOCATIONS'),
  get_staff_locations: createRequestActionTypes('GET_STAFF_LOCATIONS'),
  get_masterdata: createRequestActionTypes('GET_MASTERSDATA'),
  search_patient: createRequestActionTypes('SEARCH_PATIENT'),
  delete_appointment: createRequestActionTypes('DELETE_APPOINTMENT'),
  get_appointment_by_id: createRequestActionTypes('GET_APPOINTMENT'),
  get_users: createRequestActionTypes('GET_USERS'),
  get_staffsList: createRequestActionTypes('GET_STAFFSLIST'),
  get_user_by_id: createRequestActionTypes('GET_USERS_BY_ID'),
  delete_user: createRequestActionTypes('DELETE_USER'),
  delete_staffDetails: createRequestActionTypes('DELETE_STAFFDETAILS'),
  get_masterCustomLabels: createRequestActionTypes('GET_MASTERCUSTOMLABELS'),
  post_staffCustomValues: createRequestActionTypes('POST_STAFFCUSTOMVALUES'),
  get_master_tags: createRequestActionTypes('GET_MASTERTAGS'),
  post_user_tag: createRequestActionTypes('POST_USER_TAG'),
  get_availability_template_by_id: createRequestActionTypes('GET_AVAILABILITY_TEMPLATE_BY_ID'),
  save_availibility_template: createRequestActionTypes('SAVE_AVAILIBILITY_TEMPLATE'),
  patch_staff_active_status: createRequestActionTypes('PATCH_STAFF_ACTIVE_STATUS'),
  patch_staff_scheduler_lock: createRequestActionTypes('PATCH_STAFF_SCHEDULER_LOCK'),
  patch_staff_lock_status: createRequestActionTypes('PATCH_STAFF_LOCK_STATUS'),
  get_user_master_tags: createRequestActionTypes('GET_PATIENT_MASTER_TAGS'),
  user_menu_show_status: createRequestActionTypes('USER_MENU_SHOW_STATUS'),
  get_office_hours: createRequestActionTypes('USER_GET_OFFICE_HOURS'),
  get_staffLocations: createRequestActionTypes('USER_GET_STAFFLOCATIONS'),
  get_applied_leave_list: createRequestActionTypes('GET_APPLIED_STAFF_LEAVE'),
  post_staff_leave: createRequestActionTypes('POST_STAFF_LEAVE'),
  get_applied_leave_by_id: createRequestActionTypes('GET_APPLY_LEAVE_BY_ID'),
  delete_applied_leave: createRequestActionTypes('DELETE_APPLIED_LEAVE'),
  update_leave_status: createRequestActionTypes('UPDATE_LEAVE_STATUS'),
  get_staff_time_sheet: createRequestActionTypes('GET_STAFF_TIME_SHEET_DATA'),
  update_staff_time_sheet: createRequestActionTypes('UPDATE_STAFF_TIME_SHEET'),
  get_staff_time_sheet_table_view: createRequestActionTypes('GET_STAFF_TIME_SHEET_DATA_TABLE_VIEW'),
  get_staff_and_patient_bylocation: createRequestActionTypes('GET_STAFF_AND_PATIENT_BYLOCATION'),
  save_user_time_sheet_details: createRequestActionTypes('SAVE_USER_TIME_SHEET_DETAILS'),
  get_user_time_sheet_by_id: createRequestActionTypes('GET_USER_TIME_SHEET_BY_ID'),
  delete_user_time_sheet: createRequestActionTypes('DELETE_USER_TIME_SHEET_DETAILS'),
  submit_timesheet_status: createRequestActionTypes('SUBMIT_TIMESHEET_STATUS'),
  get_staffPayrollRates: createRequestActionTypes('GET_STAFFPAYROLLRATES'),
  post_staffPayrollRates: createRequestActionTypes('POST_STAFFPAYROLLRATES'),
  get_patient_list: createRequestActionTypes('GET_PATIENT_LIST'),
  Post_Staff_Internal_Notes: createRequestActionTypes('POST_STAFF_INTERNAL_NOTES'),  
  Get_Staff_Internal_Notes: createRequestActionTypes('GET_STAFF_INTERNAL_NOTES'),
  Delete_Staff_Internal_Notes: createRequestActionTypes('DELETE_STAFF_INTERNAL_NOTES'),
  get_StaffByTags: createRequestActionTypes('GET_STAFFBYTAGS'),
  get_ClientByTags: createRequestActionTypes('GET_CLIENTBYTAGS'),
  get_staffTrainingTitleHours: createRequestActionTypes('GET_STAFF_TRAINING_TITLE_HOURS_API'),
  post_staffTrainingTitleHours: createRequestActionTypes('POST_STAFF_TRAINING_TITLE_HOURS_API'),
  get_userRoles: createRequestActionTypes('GET_USERROLES_API'),
  get_appointmentType: createRequestActionTypes('GET_APPOINTMENTTYPELIST'),
  post_resetUserEmail: createRequestActionTypes('POST_RESETUSEREMAIL'),
  post_checkEmailChangeValidation: createRequestActionTypes('POST_CHECKEMAILCHANGEVALIDATION'),
};


export const MODULE = 'USER_INFORMATION';



// WEBPACK FOOTER //
// ./src/modules/users/constants/ApiConstants.js